import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "phoneDisplay"]
  static values = { phoneNumber: String }

  connect() {
    // Close modal when clicking outside
    this.modalTarget.addEventListener("click", (e) => {
      if (e.target === this.modalTarget) {
        this.close()
      }
    })

    // Close modal with Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
        this.close()
      }
    })
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  showPhone(event) {
    event.preventDefault()
    if (this.hasPhoneNumberValue && this.phoneNumberValue) {
      this.phoneDisplayTarget.textContent = `Appeler ${this.phoneNumberValue}`
      this.phoneDisplayTarget.href = `tel:${this.phoneNumberValue}`
      this.phoneDisplayTarget.classList.remove("hidden")
      // Don't close the modal, let user see the phone number and call button
    }
  }

}

